import Vue from "vue";
import App from "./App.vue";
import {Vuelidate} from "vuelidate";
import router from "./router";

import store from "./core/services/store";
import ApiService from "./core/services/api.service";
import MockService from "./core/mock/mock.service";
import {VERIFY_AUTH} from "./core/services/store/auth.module";
import {RESET_LAYOUT_CONFIG} from "./core/services/store/config.module";
import VuePapaParse from "vue-papa-parse";
import {Datetime} from "vue-datetime";
// You need a specific loader for CSS files
import "vue-datetime/dist/vue-datetime.css";
import VueApexCharts from "vue-apexcharts";
import * as Sentry from "@sentry/vue";
import {BrowserTracing} from "@sentry/tracing";
// import VueRouter from 'vue-router';

// Vue.use(VueRouter);
Vue.use(Vuelidate);
Vue.use(VueApexCharts);
Vue.use(Datetime);
Vue.use(VuePapaParse);
Vue.config.productionTip = false;
// import Router from "vue-router";
// Vue.use(Router);

// Global 3rd party plugins
import "popper.js";
import "tooltip.js";
import PerfectScrollbar from "perfect-scrollbar";

window.PerfectScrollbar = PerfectScrollbar;
import ClipboardJS from "clipboard";

window.ClipboardJS = ClipboardJS;
import * as VueGoogleMaps from "vue2-google-maps";

Vue.use(VueGoogleMaps, {
    load: {
        key: "AIzaSyDXH-2whjTv_FZQswBs47jyO4JGo6B5ThA",
        libraries: "places"
    }
});
// Sentry initialization and integration


// Vue 3rd party plugins
import i18n from "@/core/plugins/vue-i18n";
import vuetify from "@/core/plugins/vuetify";
import "@/core/plugins/portal-vue";
import "@/core/plugins/bootstrap-vue";
import "@/core/plugins/perfect-scrollbar";
import "@/core/plugins/highlight-js";
import "@/core/plugins/inline-svg";
import "@/core/plugins/apexcharts";
import "@/core/plugins/treeselect";
import "@/core/plugins/metronic";
import "@mdi/font/css/materialdesignicons.css";
import "@/core/plugins/formvalidation";
import { getData, capitalizeWords} from "@/utils";

// API service init
ApiService.init();

// Remove this to disable mock API
MockService.init();

async function checkFeatureEnabled(to) {
    let target = capitalizeWords(to['name'])
    let arrayFeatureName = ['Benchmark Analytics', 'Locations', 'Recommendations', 'Aben Overview',
    'Segments Dashboard', 'Segments List' ,'Subscribers', 'Campaigns', 'Campaign Analytics', 'Campaign Flows',
    'Templates', 'Consumer Insights Analytics', 'Demographics', 'Customer Journey', 'Summary', 'Locations Summary']

    let featureCompany = await store.getters["getFeaturePage"];
    if (featureCompany ==  null || featureCompany.length == 0){
      await store.dispatch("featurePage");
      featureCompany = await store.getters["getFeaturePage"];
    }
    console.log('--Company Feature: ', featureCompany)
    let ifExistInFeature = featureCompany.filter(item => item.name == target)

    if (arrayFeatureName.includes(target) && ifExistInFeature.length <= 0){
        router.push("/no-access")
    }
}


router.beforeEach((to, from, next) => {
    // checkFeatureEnabled(to)
    if(to.matched.some(record=>record.path == "/login")){
        console.log("router.beforeEach found /login");
        // Store.dispatch('auth0HandleAuthentication');
        next(false);
      }
    // Ensure we checked auth before each page load.
    Promise.all([store.dispatch(VERIFY_AUTH)]).then(next);

    // reset config to initial state
    store.dispatch(RESET_LAYOUT_CONFIG);

    // Scroll page to top on every route change
    setTimeout(() => {
        window.scrollTo(0, 0);
    }, 100);
});

router.afterEach((to, from) => {
    checkFeatureEnabled(to)
})
// Sentry tracing integration

Sentry.init({
    Vue,
    dsn: "https://8f98fe3a629b41e5a7ab4c6a914cd2c4@o224017.ingest.sentry.io/6219522",
    integrations: [
        new BrowserTracing({
            routingInstrumentation: Sentry.vueRouterInstrumentation(router),
            tracingOrigins: ["http://127.0.0.1:8000/", "https://staging-aben.herokuapp.com/", "https://app.joinaben.com/", /^\//],
        }),
    ],
    tracesSampleRate: 1.0,
});

new Vue({
    router,
    store,
    i18n,
    vuetify,
    render: h => h(App)
}).$mount("#app");
